import { CheckoutCustomer } from "../CheckoutCustomer";
import { CheckoutOrderType } from "../CheckoutOrderType";
import { CheckoutPharmacyIndication } from "../CheckoutPharmacyIndication";
import { CheckoutPharmacyIntervention } from "../CheckoutPharmacyIntervention";
import { CheckoutTable } from "../CheckoutTable";
import styles from "./styles.module.scss";

export const CheckoutGroup = ({
  style,
  btnStyle,
  className = "",
  storeDetails = {},
}) => {
  return (
    <div
      className={`${styles.checkoutGroup} ${className}`}
      style={{ ...style }}
    >
      <CheckoutCustomer btnStyle={btnStyle} />
      {storeDetails?.allow_table ? (
        <>
          <CheckoutTable btnStyle={btnStyle} />
          <CheckoutOrderType btnStyle={btnStyle} />
        </>
      ) : null}

      {!storeDetails?.allow_table ? (
        <>
          <CheckoutPharmacyIntervention btnStyle={btnStyle} />
          <CheckoutPharmacyIndication btnStyle={btnStyle} />
        </>
      ) : null}
    </div>
  );
};
